<template>
      <span>
        <span class="container">
          <div class="row">
          <div class="col-10">
            <input
            maxLength="1000"
            id="input-choice_text"
            v-model.lazy="rpsCaseChoice.choice_text"
            :class="!rpsCaseChoice || rpsCaseChoice.choice_text.length === 0 ? 'error form-control' : 'form-control'"
            @input="debounce_inputs"
            v-b-tooltip.hover.bottom="otherLocalesHoverText('choice_text')"
            />
          </div>
          <div class="col-2 align-self-center">
            <span v-if="showDelete" v-b-tooltip.hover.bottom="$t('delete')"><font-awesome-icon tabindex="-1" style="cursor: pointer;" icon="minus" @click="del"/>&nbsp;&nbsp;&nbsp;</span>
            <span v-if="showDown" v-b-tooltip.hover.bottom="$t('down')"><font-awesome-icon tabindex="-1" style="cursor: pointer;" icon="arrow-down" @click="down"/>&nbsp;&nbsp;&nbsp;</span>
            <font-awesome-icon tabindex="-1" style="cursor: pointer;" icon="arrow-up" v-if="showUp" @click="up" v-b-tooltip.hover.bottom="$t('up')"/>
          </div>
          </div>
        </span>
      </span>
  </template>
  
  <script>
  import Vue from 'vue';

  const debounce = require("lodash.debounce");

  export default {
    props: ["rpsCaseChoice", "showDown", "showUp", "showDelete", "otherLocales"],
    data() {
      return {
      };
    },
    mounted(
    ) {

    },
    beforeDestroy() {
    },
    methods: {
      debounce_inputs(e) {
        // Check if event and target exist
        if (!e || !e.target || !e.target.id) {
          return;
        }

        // assumes that input field's id is the same as member in rpsScenario, prefixed by 'input-'
        const field = e.target.id.replace('input-', '');

        if (e.target.value.length <= 1) {
          // Change immediately if field either cleared or inputted something
          Vue.set(this.rpsCaseChoice, field, e.target.value);
        } else {
          debounce(() => {
            Vue.set(this.rpsCaseChoice, field, e.target.value);
          }, this.debounceDelay)(e)
        }
      },      
      onEnter(event) {
        event.target.blur();
      },      
      isValid() {
        return this.rpsCaseChoice.choice_text.length;
      },      
      down() {
        this.$bus.$emit("rps-case-choice-down", (this.rpsCaseChoice));
      },
      del() {
        this.$bus.$emit("rps-case-choice-delete", (this.rpsCaseChoice));
      },      
      up() {
        this.$bus.$emit("rps-case-choice-up", (this.rpsCaseChoice));
      },
      otherLocalesHoverText(field) {
        let locales = "";

        for (let i = 0; i < this.otherLocales.length; i++) {
          if (this.otherLocales[i][field] && this.otherLocales[i][field].length > 0) {
            locales += this.otherLocales[i].locale + ": " + this.otherLocales[i][field] + "\n";
          }
        }
        return locales;
      },
      enter(el, done) {
        el.style.opacity = '0';
        el.style.transform = 'translateX(30px)';
        
        requestAnimationFrame(() => {
          el.style.transition = 'all 500ms ease';
          el.style.opacity = '1';
          el.style.transform = 'translateX(0)';
        });

        setTimeout(done, 500);
      },
      leave(el, done) {
        el.style.transition = 'all 500ms ease';
        el.style.opacity = '0';
        el.style.transform = 'translateX(30px)';
        
        setTimeout(done, 500);
      },
      enterChoice(el, done) {
        el.style.opacity = '0';
        el.style.transform = 'translateX(30px)';
        
        requestAnimationFrame(() => {
          el.style.transition = 'all 500ms ease';
          el.style.opacity = '1';
          el.style.transform = 'translateX(0)';
        });

        setTimeout(done, 500);
      },
      leaveChoice(el, done) {
        el.style.transition = 'all 500ms ease';
        el.style.opacity = '0';
        el.style.transform = 'translateX(30px)';
        
        setTimeout(done, 500);
      }
    }
  };
  </script>

<i18n>
  {
    "en": {
      "delete": "Delete this option",
      "up": "Move this option up",
      "down": "Move this option down"     
    },
    "fi": {
      "delete": "Poista tämä vaihtoehto",
      "up": "Siirrä ylös",
      "down": "Siirrä alas"
    }
  }
  </i18n>
  
  <style scoped>
  ::v-deep .error {
    border-color: red !important;
  }
</style>
